import api from "./api";

// 删除企业模板
export async function deleteAgentUserGlobalTemplate(id: number[]) {
  const res = await api.post<unknown>(`/agent/user-global-template/delete`, {
    id: id,
  });
  return res.data;
}
